import { JumpingLoader, TableBody, TableCell, TableRow } from '~/UIKit';
import React, { ReactElement } from 'react';
import { CellTypes, Row as IRow, Column } from './DataTable.types';
import { Row } from './Components/Row';
import { makeStyles } from '~/UIKit/Style';
export type DataTableProps = {
  rows: IRow[];
  headers: Column[];
  isLoading?: boolean;
  getCellForType: (type: CellTypes) => (props: any) => JSX.Element | null;
  selectRow: (row: any) => void;
  selectedRows: any[];
  useSelectableRows?: boolean;
  onRowClicked?: (row: any) => void;
  rowsAreExpandable?: boolean;
  getExpandedRow?: (value: any) => ReactElement;
};

const useStyles = makeStyles({
  loading: {
    height: 60,
  },
});

const DataTableComponent = ({
  isLoading,
  headers,
  rows,
  getCellForType,
  selectRow,
  onRowClicked,
  useSelectableRows,
  getExpandedRow,
  rowsAreExpandable,
}: DataTableProps) => {
  const { classes } = useStyles();

  return (
    <TableBody>
      {isLoading ? (
        <TableRow>
          <TableCell colSpan={headers.length} className={classes.loading}>
            <JumpingLoader />
          </TableCell>
        </TableRow>
      ) : (
        rows.map((row: IRow, index: number) => (
          <Row
            testId={index}
            row={row}
            key={index}
            getCellForType={getCellForType}
            onRowClicked={onRowClicked}
            isExpandable={rowsAreExpandable}
            getExpandedRow={getExpandedRow}
            selectRow={selectRow}
            useSelectableRows={useSelectableRows}
          />
        ))
      )}
    </TableBody>
  );
};

export default DataTableComponent;
